import { render, staticRenderFns } from "./SectionVideo.vue?vue&type=template&id=3b58eda6&"
import script from "./SectionVideo.vue?vue&type=script&lang=js&"
export * from "./SectionVideo.vue?vue&type=script&lang=js&"
import style0 from "./SectionVideo.vue?vue&type=style&index=0&id=3b58eda6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,AtomsCommonSliderAtomVideoSlider: require('/app/components/atoms/common/slider/AtomVideoSlider.vue').default})
